export const USER_TYPE = {
	APPLICANT: 'applicant',
	ORGANIZATION_MEMBER: 'organization_member'
}

export function isApplicantAccount(user = {}) {
	return user?.type === USER_TYPE.APPLICANT
}

export function isOrganizationMemberAccount(user = {}) {
	return user?.type === USER_TYPE.ORGANIZATION_MEMBER
}

export function hasApplicantProfile(user = {}) {
	return Boolean(user?.applicant_profile)
}

// Backend account invariant:
// applicant users may have applicant_profile and no current_organization.
// organization_member users may have current_organization and no applicant_profile.
// A payload with both is invalid, not a supported hybrid account state.
export function isOrganizationApplicationContext(user = {}) {
	return (
		isOrganizationMemberAccount(user) &&
		Boolean(user?.current_organization) &&
		!hasApplicantProfile(user)
	)
}

export function canAccessApplicantAssessment(user = {}) {
	return isApplicantAccount(user) && hasApplicantProfile(user)
}
